'use strict';
module Patersons {

    export interface QuickSearchScope extends ng.IScope {
        events: QuickSearchCtrl;

    }

    export class QuickSearchCtrl extends ResearchBaseCtrl {
        scope: Patersons.QuickSearchScope;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;

            this.load();
        }
        load() {
            rootMorningstarPromise().then(function (promiseChain) {
                console.log('initializing component');
                    initComponent('component-autocomplete-search', 'ecAutocomplete-container', 'ec-autocomplete', 'ecAutocompleteSearch').then(function () {
                        console.log('Done loading autocomplete search.');
                        morningstar.asterix.instanceRegistry.find('ecAutocompleteSearch').on('parameterChanged:latestSelectedSecurity', function (newVal) {
                            window['openAutocompleteResult'](newVal) //declared in autocomplete config
                            morningstar.asterix.instanceRegistry.get('ecAutocompleteSearch').setParameter('search', '');
                        });
                    });
            });
        }
    }
}